<template>
  <div v-if="presentations.length" class="stat-list">
    <div v-for="p in presentations" :key="p.key" class="stat-row">
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="rgba(211,202,87,0.8)"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="flex-shrink: 0"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
      <div class="stat-label">
        <strong>{{ p.name }}</strong>
        <div class="stat-meta">
          <span class="stat-meta-item">
            {{ p.slides }} slide{{ p.slides === 1 ? '' : 's' }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <p>No presentations were shared in this session.</p>
  </div>
</template>

<script>
export default {
  name: 'PresentationTab',
  props: {
    presentations: { type: Array, default: () => [] },
  },
};
</script>
